import React from 'react';

const SidebarItem = ({ icon: Icon, label, active, onClick, badge, theme = 'dark' }) => {
    const isLight = theme === 'light';

    return (
        <button
            onClick={onClick}
            className={`w-full flex items-center justify-between px-2.5 py-2 rounded-lg transition-all duration-200 group relative overflow-hidden ${active
                ? (isLight ? 'bg-gradient-to-r from-cyan-500 to-cyan-600 text-white shadow-sm shadow-cyan-500/20' : 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-sm shadow-blue-500/20')
                : (isLight ? 'text-slate-600 hover:bg-cyan-50 hover:text-cyan-700' : 'text-slate-400 hover:bg-slate-800/50 hover:text-white')
                }`}
        >
            <div className="flex items-center gap-2.5 relative z-10 w-full">
                <div className={`p-1.5 rounded-md transition-colors ${active
                    ? 'bg-white/20'
                    : (isLight ? 'bg-slate-100 group-hover:bg-cyan-100' : 'bg-slate-800 group-hover:bg-slate-700')
                    }`}>
                    <Icon className={`h-4 w-4 ${active
                        ? 'text-white'
                        : (isLight ? 'text-slate-500 group-hover:text-cyan-600' : 'text-slate-400 group-hover:text-blue-400')
                        }`} />
                </div>
                <span className="font-medium text-sm truncate flex-1 text-left">{label}</span>
                {badge && (
                    <span className={`px-1.5 py-0.5 rounded-full text-[10px] font-bold ${active
                        ? 'bg-white/20 text-white'
                        : (isLight ? 'bg-cyan-100 text-cyan-700' : 'bg-blue-500/10 text-blue-400')
                        }`}>
                        {badge}
                    </span>
                )}
            </div>
            {active && (
                <div className="absolute inset-0 bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity" />
            )}
        </button>
    );
};

export default SidebarItem;
